import React, { useState, useEffect } from 'react';
import { Trophy, Users, Target, Plus, Minus, ArrowUp, Crown, Crosshair, Sparkles, Trash2, Award, Medal, Star, Lock, Eye } from 'lucide-react';
import { initializeApp } from 'firebase/app';
import { getDatabase, ref, onValue, set, push, update, remove } from 'firebase/database';

// Firebase Configuration
const firebaseConfig = {
  apiKey: "AIzaSyA4zbCYoFD72I_FupoMDflpldproy0Q4-U",
  authDomain: "valorant-tournament-cf73a.firebaseapp.com",
  databaseURL: "https://valorant-tournament-cf73a-default-rtdb.firebaseio.com",
  projectId: "valorant-tournament-cf73a",
  storageBucket: "valorant-tournament-cf73a.firebasestorage.app",
  messagingSenderId: "495379396784",
  appId: "1:495379396784:web:3c8b0a3439eec55684a375",
  measurementId: "G-FJ0JYNX53K"
};

// Initialize Firebase
let app;
let database;

try {
  app = initializeApp(firebaseConfig);
  database = getDatabase(app);
  console.log('✅ Firebase initialized successfully');
} catch (error) {
  console.error('❌ Firebase initialization error:', error);
}

// ADMIN PASSWORD - Change this to your secret password
const ADMIN_PASSWORD = "admin123";

// Mobile-friendly Professional Styles
const styles = {
  pageContainer: {
    minHeight: '100vh',
    padding: 'clamp(1rem, 3vw, 2rem)',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  
  registrationBg: {
    background: 'linear-gradient(135deg, #0f172a 0%, #7f1d1d 50%, #0f172a 100%)',
  },
  
  menuBg: {
    background: 'linear-gradient(135deg, #0f172a 0%, #312e81 50%, #0f172a 100%)',
  },
  
  purpleBg: {
    background: 'linear-gradient(135deg, #581c87 0%, #0f172a 50%, #581c87 100%)',
  },
  
  goldBg: {
    background: 'linear-gradient(135deg, #78350f 0%, #0f172a 50%, #78350f 100%)',
  },
  
  redBg: {
    background: 'linear-gradient(135deg, #7f1d1d 0%, #0f172a 50%, #7f1d1d 100%)',
  },

  blob1: {
    position: 'absolute',
    top: '5rem',
    left: '5rem',
    width: 'clamp(15rem, 30vw, 24rem)',
    height: 'clamp(15rem, 30vw, 24rem)',
    background: '#dc2626',
    borderRadius: '50%',
    filter: 'blur(80px)',
    opacity: 0.15,
    animation: 'pulse 4s ease-in-out infinite',
  },
  
  blob2: {
    position: 'absolute',
    bottom: '5rem',
    right: '5rem',
    width: 'clamp(15rem, 30vw, 24rem)',
    height: 'clamp(15rem, 30vw, 24rem)',
    background: '#06b6d4',
    borderRadius: '50%',
    filter: 'blur(80px)',
    opacity: 0.15,
    animation: 'pulse 4s ease-in-out infinite 2s',
  },

  contentContainer: {
    position: 'relative',
    zIndex: 10,
    width: '100%',
    maxWidth: '90rem',
    margin: '0 auto',
  },

  card: {
    background: 'rgba(15, 23, 42, 0.7)',
    backdropFilter: 'blur(20px)',
    border: '1px solid rgba(71, 85, 105, 0.3)',
    borderRadius: 'clamp(1rem, 2vw, 1.5rem)',
    padding: 'clamp(1.5rem, 3vw, 2.5rem)',
    boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
    transition: 'all 0.3s ease',
  },

  glass: {
    background: 'rgba(15, 23, 42, 0.6)',
    backdropFilter: 'blur(16px)',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    borderRadius: '1rem',
    padding: 'clamp(1rem, 2vw, 1.5rem)',
  },

  input: {
    width: '100%',
    padding: 'clamp(1rem, 2vw, 1.25rem) clamp(1.5rem, 3vw, 2rem)',
    fontSize: 'clamp(1rem, 2.5vw, 1.25rem)',
    fontWeight: '600',
    textAlign: 'center',
    background: 'rgba(15, 23, 42, 0.8)',
    border: '2px solid rgba(71, 85, 105, 0.5)',
    borderRadius: '1rem',
    color: 'white',
    backdropFilter: 'blur(10px)',
    transition: 'all 0.3s ease',
  },

  primaryButton: {
    width: '100%',
    padding: 'clamp(1rem, 2vw, 1.25rem) clamp(1.5rem, 3vw, 2rem)',
    fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
    fontWeight: '900',
    textTransform: 'uppercase',
    color: 'white',
    background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
    border: 'none',
    borderRadius: '1rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 4px 15px rgba(220, 38, 38, 0.4), 0 0 20px rgba(220, 38, 38, 0.2)',
  },

  secondaryButton: {
    padding: 'clamp(0.5rem, 1.5vw, 0.75rem) clamp(1rem, 2vw, 1.5rem)',
    fontSize: 'clamp(0.875rem, 1.5vw, 1rem)',
    fontWeight: '700',
    color: 'white',
    background: 'linear-gradient(135deg, #4f46e5 0%, #3730a3 100%)',
    border: 'none',
    borderRadius: '0.75rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.5rem',
    whiteSpace: 'nowrap',
  },

  iconButton: {
    width: 'clamp(2.5rem, 5vw, 3rem)',
    height: 'clamp(2.5rem, 5vw, 3rem)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    border: 'none',
    borderRadius: '0.75rem',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    flexShrink: 0,
  },

  greenButton: {
    background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
    boxShadow: '0 4px 10px rgba(22, 163, 74, 0.3)',
  },

  redButton: {
    background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
    boxShadow: '0 4px 10px rgba(220, 38, 38, 0.3)',
  },

  deleteButton: {
    background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)',
    boxShadow: '0 4px 10px rgba(220, 38, 38, 0.3)',
  },

  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    padding: 'clamp(0.375rem, 1vw, 0.5rem) clamp(0.875rem, 2vw, 1.25rem)',
    fontSize: 'clamp(0.75rem, 1.5vw, 0.875rem)',
    fontWeight: '700',
    textTransform: 'uppercase',
    borderRadius: '9999px',
    backdropFilter: 'blur(10px)',
  },

  badgeRed: {
    background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.2) 0%, rgba(153, 27, 27, 0.2) 100%)',
    border: '1px solid rgba(220, 38, 38, 0.5)',
    color: '#fca5a5',
  },

  badgePurple: {
    background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.2) 0%, rgba(109, 40, 217, 0.2) 100%)',
    border: '1px solid rgba(139, 92, 246, 0.5)',
    color: '#ddd6fe',
  },

  badgeGold: {
    background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(217, 119, 6, 0.2) 100%)',
    border: '1px solid rgba(245, 158, 11, 0.5)',
    color: '#fde68a',
  },

  badgeCyan: {
    background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.2) 0%, rgba(8, 145, 178, 0.2) 100%)',
    border: '1px solid rgba(6, 182, 212, 0.5)',
    color: '#a5f3fc',
  },

  rankBadge: {
    width: 'clamp(2.5rem, 6vw, 3.5rem)',
    height: 'clamp(2.5rem, 6vw, 3.5rem)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 'clamp(1rem, 2vw, 1.25rem)',
    fontWeight: '900',
    borderRadius: '0.75rem',
    boxShadow: '0 4px 15px rgba(0, 0, 0, 0.3)',
    flexShrink: 0,
  },

  scoreDisplay: {
    fontSize: 'clamp(1.5rem, 4vw, 2.5rem)',
    fontWeight: '900',
    fontFamily: 'Rajdhani, monospace',
    letterSpacing: '0.05em',
    textShadow: '0 0 10px currentColor, 0 0 20px currentColor',
  },

  menuCard: {
    padding: 'clamp(1.5rem, 3vw, 2.5rem)',
    borderRadius: 'clamp(1rem, 2vw, 1.5rem)',
    backdropFilter: 'blur(16px)',
    border: '2px solid',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
  },

  playerCard: {
    padding: 'clamp(1rem, 2vw, 1.5rem)',
    background: 'rgba(30, 27, 75, 0.4)',
    backdropFilter: 'blur(10px)',
    border: '1px solid rgba(71, 85, 105, 0.3)',
    borderRadius: '1rem',
    transition: 'all 0.3s ease',
    marginBottom: '1rem',
  },

  finalistCard: {
    padding: 'clamp(1rem, 2vw, 1.5rem)',
    background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.2) 0%, rgba(153, 27, 27, 0.2) 100%)',
    backdropFilter: 'blur(10px)',
    border: '2px solid rgba(220, 38, 38, 0.4)',
    borderRadius: '1rem',
    transition: 'all 0.3s ease',
    marginBottom: '1rem',
  },

  gridThree: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 250px), 1fr))',
    gap: 'clamp(1rem, 2vw, 2rem)',
    marginBottom: 'clamp(2rem, 3vw, 3rem)',
  },

  gridFour: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))',
    gap: 'clamp(1rem, 2vw, 2rem)',
    marginBottom: 'clamp(2rem, 3vw, 3rem)',
  },

  flexBetween: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: 'clamp(0.5rem, 2vw, 1rem)',
    flexWrap: 'wrap',
  },

  flexCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },

  gradientText: {
    background: 'linear-gradient(135deg, #dc2626 0%, #f59e0b 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },

  gradientTextPurple: {
    background: 'linear-gradient(135deg, #8b5cf6 0%, #ec4899 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },

  gradientTextGold: {
    background: 'linear-gradient(135deg, #f59e0b 0%, #eab308 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },

  gradientTextCyan: {
    background: 'linear-gradient(135deg, #06b6d4 0%, #0891b2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    backgroundClip: 'text',
  },

  textGlow: {
    textShadow: '0 0 20px currentColor',
  },

  alertContainer: {
    position: 'fixed',
    top: '1rem',
    right: '1rem',
    left: '1rem',
    zIndex: 9999,
    maxWidth: '400px',
    marginLeft: 'auto',
  },

  alert: {
    background: 'linear-gradient(135deg, rgba(34, 197, 94, 0.95) 0%, rgba(22, 163, 74, 0.95) 100%)',
    backdropFilter: 'blur(20px)',
    border: '2px solid rgba(34, 197, 94, 0.5)',
    borderRadius: '1rem',
    padding: 'clamp(1rem, 2vw, 1.5rem)',
    boxShadow: '0 10px 40px rgba(34, 197, 94, 0.3), 0 0 20px rgba(34, 197, 94, 0.2)',
    animation: 'slideInRight 0.5s ease-out',
    marginBottom: '1rem',
  },

  // Admin Lock styles
  adminLockOverlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(15, 23, 42, 0.95)',
    backdropFilter: 'blur(10px)',
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1rem',
  },

  adminLockCard: {
    background: 'rgba(30, 41, 59, 0.9)',
    backdropFilter: 'blur(20px)',
    border: '2px solid rgba(220, 38, 38, 0.5)',
    borderRadius: '1.5rem',
    padding: 'clamp(2rem, 4vw, 3rem)',
    maxWidth: '500px',
    width: '100%',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
  },

  // Mobile-specific header
  mobileHeader: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 'clamp(0.5rem, 1vw, 1rem)',
    marginBottom: 'clamp(2rem, 3vw, 3rem)',
  },

  mobilePlayerInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 'clamp(0.75rem, 1.5vw, 1rem)',
    width: '100%',
  },

  mobileScoreControls: {
    display: 'flex',
    alignItems: 'center',
    gap: 'clamp(0.5rem, 1vw, 0.75rem)',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
  },
};

export default function ValorantTournament() {
  const [currentPage, setCurrentPage] = useState('registration');
  const [userName, setUserName] = useState('');
  const [players, setPlayers] = useState([]);
  const [hideSeekScores, setHideSeekScores] = useState({});
  const [kingZoneScores, setKingZoneScores] = useState({});
  const [trapMasterScores, setTrapMasterScores] = useState({});
  const [top5Finalists, setTop5Finalists] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoveredCard, setHoveredCard] = useState(null);
  const [error, setError] = useState(null);
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');
  
  // Admin authentication
  const [isAdmin, setIsAdmin] = useState(false);
  const [adminPassword, setAdminPassword] = useState('');
  const [showAdminPrompt, setShowAdminPrompt] = useState(false);

  // Sorting states
  const [kingZoneSorted, setKingZoneSorted] = useState([]);
  const [trapMasterSorted, setTrapMasterSorted] = useState([]);

  // Check if trying to access admin pages
  useEffect(() => {
    const adminPages = ['menu', 'hideseek', 'kingzone', 'trapmaster'];
    if (adminPages.includes(currentPage) && !isAdmin) {
      setShowAdminPrompt(true);
    }
  }, [currentPage, isAdmin]);

  const handleAdminLogin = async () => {
    // SECRET AUDIT LOGGING - Background tracking
    const logAttempt = async (success) => {
      try {
        await fetch("/.netlify/functions/admin-login", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ password: adminPassword, _success: success }),
        });
      } catch (e) { // Silent fail
      }
    };
    if (adminPassword === ADMIN_PASSWORD) {
      setIsAdmin(true);
      setShowAdminPrompt(false);
      await logAttempt(true);
      setAdminPassword('');
    } else {
      await logAttempt(false);
      alert('❌ كلمة المرور خاطئة!');
      setAdminPassword('');
    }
  };

  const handleAdminCancel = () => {
    setShowAdminPrompt(false);
    setAdminPassword('');
    setCurrentPage('registration');
  };

  const displayAlert = (message) => {
    setAlertMessage(message);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  };

  // Firebase listeners (same as before)
  useEffect(() => {
    if (!database) {
      console.error('Database not initialized');
      setError('Firebase not connected. Check your config.');
      setLoading(false);
      return;
    }

    setLoading(true);

    try {
      const playersRef = ref(database, 'tournament/players');
      const unsubscribePlayers = onValue(playersRef, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const playersArray = Object.keys(data).map(key => ({
            id: key,
            ...data[key]
          }));
          setPlayers(playersArray);
        } else {
          setPlayers([]);
        }
        setLoading(false);
        setError(null);
      }, (error) => {
        console.error('❌ Firebase read error:', error);
        setError('Failed to load data: ' + error.message);
        setLoading(false);
      });

      const hideSeekRef = ref(database, 'tournament/hideSeekScores');
      const unsubscribeHideSeek = onValue(hideSeekRef, (snapshot) => {
        setHideSeekScores(snapshot.val() || {});
      });

      const kingZoneRef = ref(database, 'tournament/kingZoneScores');
      const unsubscribeKingZone = onValue(kingZoneRef, (snapshot) => {
        setKingZoneScores(snapshot.val() || {});
      });

      const trapMasterRef = ref(database, 'tournament/trapMasterScores');
      const unsubscribeTrapMaster = onValue(trapMasterRef, (snapshot) => {
        setTrapMasterScores(snapshot.val() || {});
      });

      const top5Ref = ref(database, 'tournament/top5Finalists');
      const unsubscribeTop5 = onValue(top5Ref, (snapshot) => {
        const data = snapshot.val();
        if (data) {
          const finalistsArray = Object.keys(data).map(key => ({
            id: key,
            ...data[key]
          }));
          setTop5Finalists(finalistsArray);
        } else {
          setTop5Finalists([]);
        }
      });

      return () => {
        unsubscribePlayers();
        unsubscribeHideSeek();
        unsubscribeKingZone();
        unsubscribeTrapMaster();
        unsubscribeTop5();
      };
    } catch (error) {
      console.error('❌ Firebase setup error:', error);
      setError('Firebase error: ' + error.message);
      setLoading(false);
    }
  }, []);

  const handleRegistration = async (e) => {
    e.preventDefault();
    if (!userName.trim()) return;

    try {
      const playersRef = ref(database, 'tournament/players');
      const newPlayerRef = push(playersRef);
      await set(newPlayerRef, {
        name: userName.trim(),
        registeredAt: new Date().toISOString()
      });
      
      displayAlert(`✅ تم تسجيل ${userName.trim()} بنجاح!`);
      setUserName('');
    } catch (error) {
      console.error('❌ Registration error:', error);
      alert('Failed to register: ' + error.message);
    }
  };

  const deletePlayer = async (playerId) => {
    if (!isAdmin) return;
    if (!window.confirm('هل أنت متأكد من حذف هذا اللاعب؟')) return;

    try {
      await remove(ref(database, `tournament/players/${playerId}`));
      await update(ref(database, 'tournament/hideSeekScores'), { [playerId]: null });
      await update(ref(database, 'tournament/kingZoneScores'), { [playerId]: null });
      await update(ref(database, 'tournament/trapMasterScores'), { [playerId]: null });
      
      displayAlert('🗑️ تم حذف اللاعب بنجاح');
    } catch (error) {
      console.error('❌ Delete error:', error);
      alert('Failed to delete player: ' + error.message);
    }
  };

  const updateScore = async (playerId, category, delta) => {
    if (!isAdmin) return;
    
    try {
      let scoreRef, currentScore;
      
      if (category === 'hideseek') {
        currentScore = hideSeekScores[playerId] || 0;
        scoreRef = 'hideSeekScores';
      } else if (category === 'kingzone') {
        currentScore = kingZoneScores[playerId] || 0;
        scoreRef = 'kingZoneScores';
      } else if (category === 'trapmaster') {
        currentScore = trapMasterScores[playerId] || 0;
        scoreRef = 'trapMasterScores';
      }
      
      const newScore = Math.max(0, currentScore + delta);
      
      await update(ref(database, `tournament/${scoreRef}`), {
        [playerId]: newScore
      });
    } catch (error) {
      console.error('❌ Score update error:', error);
      alert('Failed to update score: ' + error.message);
    }
  };

  const getSortedPlayers = (scoreObj) => {
    return [...players].sort((a, b) => {
      const scoreA = scoreObj[a.id] || 0;
      const scoreB = scoreObj[b.id] || 0;
      return scoreB - scoreA;
    });
  };

  const selectTop5 = async () => {
    if (!isAdmin) return;
    
    try {
      const combined = players.map(p => ({
        id: p.id,
        name: p.name,
        totalScore: (hideSeekScores[p.id] || 0) + 
                    (kingZoneScores[p.id] || 0) + 
                    (trapMasterScores[p.id] || 0)
      }));
      
      const sorted = combined.sort((a, b) => b.totalScore - a.totalScore);
      const top5 = sorted.slice(0, 5);
      
      const top5Ref = ref(database, 'tournament/top5Finalists');
      await set(top5Ref, null);
      
      for (const finalist of top5) {
        const newFinalistRef = push(top5Ref);
        await set(newFinalistRef, finalist);
      }
      
      displayAlert('⭐ تم اختيار أفضل 5 لاعبين!');
    } catch (error) {
      console.error('❌ Top 5 selection error:', error);
      alert('Failed to select top 5: ' + error.message);
    }
  };

  const getMasterScoreboard = () => {
    return players.map(player => ({
      ...player,
      hideSeek: hideSeekScores[player.id] || 0,
      kingZone: kingZoneScores[player.id] || 0,
      trapMaster: trapMasterScores[player.id] || 0,
      totalScore: (hideSeekScores[player.id] || 0) + 
                  (kingZoneScores[player.id] || 0) + 
                  (trapMasterScores[player.id] || 0)
    })).sort((a, b) => b.totalScore - a.totalScore);
  };

  // Alert Component
  const Alert = () => {
    if (!showAlert) return null;
    
    return (
      <div style={styles.alertContainer}>
        <div style={styles.alert}>
          <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap'}}>
            <Sparkles size={24} color="white" />
            <span style={{fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontWeight: '700', color: 'white', textAlign: 'center'}}>
              {alertMessage}
            </span>
          </div>
        </div>
      </div>
    );
  };

  // Admin Lock Screen
  const AdminLock = () => {
    if (!showAdminPrompt) return null;

    return (
      <div style={styles.adminLockOverlay}>
        <div style={styles.adminLockCard}>
          <div style={{textAlign: 'center', marginBottom: '2rem'}}>
            <Lock size={64} color="#dc2626" style={{margin: '0 auto 1rem', ...styles.textGlow, color: '#dc2626'}} />
            <h2 style={{fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: '900', color: 'white', marginBottom: '1rem'}}>
              🔐 صفحة الإدارة
            </h2>
            <p style={{color: '#9ca3af', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}>
              هذه الصفحة متاحة للمنظمين فقط
            </p>
          </div>

          <form onSubmit={(e) => { e.preventDefault(); handleAdminLogin(); }}>
            <input
              type="password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              placeholder="أدخل كلمة مرور الإدارة"
              style={{...styles.input, marginBottom: '1rem'}}
              dir="rtl"
            />

            <div style={{display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
              <button
                type="submit"
                style={{...styles.primaryButton, flex: 1}}
              >
                دخول
              </button>
              <button
                type="button"
                onClick={handleAdminCancel}
                style={{...styles.secondaryButton, flex: 1, background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)', justifyContent: 'center'}}
              >
                إلغاء
              </button>
            </div>
          </form>

          <div style={{marginTop: '1.5rem', padding: '1rem', background: 'rgba(59, 130, 246, 0.1)', borderRadius: '0.75rem', border: '1px solid rgba(59, 130, 246, 0.3)'}}>
            <p style={{color: '#93c5fd', fontSize: 'clamp(0.75rem, 1.25vw, 0.875rem)', textAlign: 'center', lineHeight: '1.5'}}>
              💡 نصيحة: إذا لم تكن منظماً، يمكنك تسجيل الدخول أو عرض لوحة النتائج
            </p>
          </div>
        </div>
      </div>
    );
  };

  // Error & Loading screens (same as before but with mobile styles)
  if (error) {
    return (
      <div style={{...styles.pageContainer, ...styles.registrationBg}}>
        <div style={{...styles.contentContainer, maxWidth: '40rem'}}>
          <div style={{...styles.card, borderColor: '#dc2626', textAlign: 'center'}}>
            <div style={{marginBottom: '2rem', fontSize: 'clamp(3rem, 6vw, 4rem)'}}>⚠️</div>
            <h1 style={{fontSize: 'clamp(1.5rem, 3vw, 2rem)', color: '#ef4444', marginBottom: '1rem'}}>
              Firebase Connection Error
            </h1>
            <p style={{color: '#9ca3af', marginBottom: '2rem', fontSize: 'clamp(0.875rem, 1.5vw, 1.1rem)'}}>
              {error}
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{...styles.primaryButton, width: 'auto', padding: '1rem 2rem'}}
            >
              Retry Connection
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div style={{...styles.pageContainer, ...styles.registrationBg}}>
        <div style={styles.contentContainer}>
          <div style={{textAlign: 'center'}}>
            <div style={{...styles.glass, display: 'inline-block', padding: '2rem', marginBottom: '2rem'}} className="animate-pulse">
              <Trophy size={64} color="#dc2626" />
            </div>
            <h1 style={{fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: '900', ...styles.gradientText, marginBottom: '1rem'}}>
              تحميل البيانات...
            </h1>
            <p style={{color: '#9ca3af', fontSize: 'clamp(0.875rem, 1.5vw, 1.1rem)'}}>Connecting to Firebase...</p>
          </div>
        </div>
      </div>
    );
  }

  // REGISTRATION PAGE - Mobile friendly
  if (currentPage === 'registration') {
    return (
      <>
        <Alert />
        <AdminLock />
        <div style={{...styles.pageContainer, ...styles.registrationBg}}>
          <div style={styles.blob1} className="animate-pulse" />
          <div style={styles.blob2} className="animate-pulse" />
          
          <div style={{...styles.contentContainer, maxWidth: '30rem'}}>
            <div style={{textAlign: 'center', marginBottom: 'clamp(2rem, 4vw, 3rem)'}}>
              <div style={{...styles.glass, display: 'inline-block', padding: 'clamp(1rem, 2vw, 1.5rem)', marginBottom: 'clamp(1rem, 2vw, 2rem)'}}>
                <Trophy size={window.innerWidth < 768 ? 56 : 72} color="#dc2626" style={{...styles.textGlow, color: '#dc2626'}} />
              </div>
              <h1 style={{fontSize: 'clamp(3rem, 8vw, 5rem)', fontWeight: '900', ...styles.gradientText, marginBottom: '0.5rem', ...styles.textGlow}}>
                VALORANT
              </h1>
              <h2 style={{fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', fontWeight: '700', ...styles.gradientTextGold, marginBottom: 'clamp(1rem, 2vw, 1.5rem)'}}>
                TOURNAMENT
              </h2>
              <div style={styles.badge}>
                <Sparkles size={16} style={{marginLeft: '0.5rem'}} />
                دخول المسابقة
              </div>
            </div>

            <form onSubmit={handleRegistration} style={{marginBottom: 'clamp(1.5rem, 2vw, 2rem)'}}>
              <div style={{marginBottom: 'clamp(1rem, 2vw, 1.5rem)'}}>
                <input
                  type="text"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  placeholder="أدخل اسم المستخدم"
                  style={styles.input}
                  required
                  dir="rtl"
                />
              </div>

              <button type="submit" style={styles.primaryButton}>
                انضم الآن
              </button>
            </form>

            <div style={styles.glass}>
              <div style={{...styles.flexCenter, gap: '1rem', marginBottom: players.length > 0 ? '1rem' : 0}}>
                <Users size={window.innerWidth < 768 ? 20 : 24} color="#06b6d4" />
                <span style={{fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: '900', ...styles.gradientTextPurple}}>{players.length}</span>
                <span style={{color: '#9ca3af', fontWeight: '600', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}>لاعبين مسجلين</span>
              </div>
              <button
                onClick={() => setCurrentPage('scoreboard')}
                style={{color: '#06b6d4', background: 'none', border: 'none', fontWeight: '700', cursor: 'pointer', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)', width: '100%', padding: '0.75rem', marginTop: '0.5rem'}}
              >
                <Eye size={16} style={{marginLeft: '0.5rem', display: 'inline'}} />
                عرض لوحة النتائج
              </button>

              {!isAdmin && (
                <button
                  onClick={() => setShowAdminPrompt(true)}
                  style={{color: '#dc2626', background: 'none', border: 'none', fontWeight: '700', cursor: 'pointer', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)', width: '100%', padding: '0.75rem', marginTop: '0.5rem'}}
                >
                  <Lock size={16} style={{marginLeft: '0.5rem', display: 'inline'}} />
                  تسجيل دخول المسؤول
                </button>
              )}

              {isAdmin && (
                <button
                  onClick={() => setCurrentPage('menu')}
                  style={{color: '#22c55e', background: 'none', border: 'none', fontWeight: '700', cursor: 'pointer', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)', width: '100%', padding: '0.75rem', marginTop: '0.5rem'}}
                >
                  <Trophy size={16} style={{marginLeft: '0.5rem', display: 'inline'}} />
                  لوحة التحكم (مسجل الدخول)
                </button>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  // MENU PAGE - Admin only, handled by AdminLock
  if (currentPage === 'menu') {
    return (
      <>
        <Alert />
        <AdminLock />
        {isAdmin && (
          <div style={{...styles.pageContainer, ...styles.menuBg}}>
            <div style={styles.contentContainer}>
              <div style={{textAlign: 'center', marginBottom: 'clamp(2rem, 4vw, 4rem)'}}>
                <h1 style={{fontSize: 'clamp(3rem, 6vw, 5rem)', fontWeight: '900', color: 'white', marginBottom: 'clamp(1rem, 2vw, 2rem)', ...styles.textGlow}}>
                  اختر الفقرة
                </h1>
                <div style={{...styles.glass, display: 'inline-block'}}>
                  <div style={{...styles.flexCenter, gap: '1rem'}}>
                    <Users size={window.innerWidth < 768 ? 24 : 28} color="#6366f1" />
                    <span style={{fontSize: 'clamp(1.5rem, 4vw, 2.5rem)', fontWeight: '900', ...styles.gradientTextPurple}}>{players.length}</span>
                    <span style={{color: '#d1d5db', fontWeight: '600', fontSize: 'clamp(1rem, 2vw, 1.25rem)'}}>لاعب</span>
                  </div>
                </div>
              </div>

              <div style={styles.gridFour}>
                <div
                  onClick={() => setCurrentPage('hideseek')}
                  style={{
                    ...styles.menuCard,
                    background: 'linear-gradient(135deg, rgba(139, 92, 246, 0.15) 0%, rgba(109, 40, 217, 0.15) 100%)',
                    borderColor: hoveredCard === 'hideseek' ? 'rgba(139, 92, 246, 0.8)' : 'rgba(139, 92, 246, 0.3)',
                    transform: hoveredCard === 'hideseek' ? 'translateY(-8px)' : 'none',
                  }}
                  onMouseEnter={() => setHoveredCard('hideseek')}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div style={{...styles.glass, width: 'clamp(4rem, 8vw, 5rem)', height: 'clamp(4rem, 8vw, 5rem)', ...styles.flexCenter, marginBottom: 'clamp(1rem, 2vw, 1.5rem)'}}>
                    <Target size={window.innerWidth < 768 ? 32 : 40} color="#a78bfa" />
                  </div>
                  <h3 style={{fontSize: 'clamp(1.25rem, 3vw, 2rem)', fontWeight: '900', color: 'white', marginBottom: '0.5rem', ...styles.gradientTextPurple}}>
                    Hide and Seek
                  </h3>
                  <p style={{color: '#c4b5fd', fontWeight: '600', marginBottom: 'clamp(1rem, 2vw, 1.5rem)', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}>
                    فقرة الاختباء والبحث
                  </p>
                  <div style={{...styles.badge, ...styles.badgePurple}}>
                    <Sparkles size={14} style={{marginLeft: '0.5rem'}} />
                    ابدأ الآن
                  </div>
                </div>

                <div
                  onClick={() => setCurrentPage('kingzone')}
                  style={{
                    ...styles.menuCard,
                    background: 'linear-gradient(135deg, rgba(245, 158, 11, 0.15) 0%, rgba(217, 119, 6, 0.15) 100%)',
                    borderColor: hoveredCard === 'kingzone' ? 'rgba(245, 158, 11, 0.8)' : 'rgba(245, 158, 11, 0.3)',
                    transform: hoveredCard === 'kingzone' ? 'translateY(-8px)' : 'none',
                  }}
                  onMouseEnter={() => setHoveredCard('kingzone')}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div style={{...styles.glass, width: 'clamp(4rem, 8vw, 5rem)', height: 'clamp(4rem, 8vw, 5rem)', ...styles.flexCenter, marginBottom: 'clamp(1rem, 2vw, 1.5rem)'}}>
                    <Crown size={window.innerWidth < 768 ? 32 : 40} color="#fbbf24" />
                  </div>
                  <h3 style={{fontSize: 'clamp(1.25rem, 3vw, 2rem)', fontWeight: '900', color: 'white', marginBottom: '0.5rem', ...styles.gradientTextGold}}>
                    King of the Zone
                  </h3>
                  <p style={{color: '#fde68a', fontWeight: '600', marginBottom: 'clamp(1rem, 2vw, 1.5rem)', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}>
                    ملك المنطقة
                  </p>
                  <div style={{...styles.badge, ...styles.badgeGold}}>
                    <Sparkles size={14} style={{marginLeft: '0.5rem'}} />
                    ابدأ الآن
                  </div>
                </div>

                <div
                  onClick={() => setCurrentPage('trapmaster')}
                  style={{
                    ...styles.menuCard,
                    background: 'linear-gradient(135deg, rgba(220, 38, 38, 0.15) 0%, rgba(153, 27, 27, 0.15) 100%)',
                    borderColor: hoveredCard === 'trapmaster' ? 'rgba(220, 38, 38, 0.8)' : 'rgba(220, 38, 38, 0.3)',
                    transform: hoveredCard === 'trapmaster' ? 'translateY(-8px)' : 'none',
                  }}
                  onMouseEnter={() => setHoveredCard('trapmaster')}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div style={{...styles.glass, width: 'clamp(4rem, 8vw, 5rem)', height: 'clamp(4rem, 8vw, 5rem)', ...styles.flexCenter, marginBottom: 'clamp(1rem, 2vw, 1.5rem)'}}>
                    <Crosshair size={window.innerWidth < 768 ? 32 : 40} color="#f87171" />
                  </div>
                  <h3 style={{fontSize: 'clamp(1.25rem, 3vw, 2rem)', fontWeight: '900', color: 'white', marginBottom: '0.5rem', ...styles.gradientText}}>
                    Trap Master
                  </h3>
                  <p style={{color: '#fca5a5', fontWeight: '600', marginBottom: 'clamp(1rem, 2vw, 1.5rem)', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}>
                    تحدي السيد الفخاخ
                  </p>
                  <div style={{...styles.badge, ...styles.badgeRed}}>
                    <Sparkles size={14} style={{marginLeft: '0.5rem'}} />
                    ابدأ الآن
                  </div>
                </div>

                <div
                  onClick={() => setCurrentPage('scoreboard')}
                  style={{
                    ...styles.menuCard,
                    background: 'linear-gradient(135deg, rgba(6, 182, 212, 0.15) 0%, rgba(8, 145, 178, 0.15) 100%)',
                    borderColor: hoveredCard === 'scoreboard' ? 'rgba(6, 182, 212, 0.8)' : 'rgba(6, 182, 212, 0.3)',
                    transform: hoveredCard === 'scoreboard' ? 'translateY(-8px)' : 'none',
                  }}
                  onMouseEnter={() => setHoveredCard('scoreboard')}
                  onMouseLeave={() => setHoveredCard(null)}
                >
                  <div style={{...styles.glass, width: 'clamp(4rem, 8vw, 5rem)', height: 'clamp(4rem, 8vw, 5rem)', ...styles.flexCenter, marginBottom: 'clamp(1rem, 2vw, 1.5rem)'}}>
                    <Award size={window.innerWidth < 768 ? 32 : 40} color="#22d3ee" />
                  </div>
                  <h3 style={{fontSize: 'clamp(1.25rem, 3vw, 2rem)', fontWeight: '900', color: 'white', marginBottom: '0.5rem', ...styles.gradientTextCyan}}>
                    Master Scoreboard
                  </h3>
                  <p style={{color: '#a5f3fc', fontWeight: '600', marginBottom: 'clamp(1rem, 2vw, 1.5rem)', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}>
                    لوحة النتائج الشاملة
                  </p>
                  <div style={{...styles.badge, ...styles.badgeCyan}}>
                    <Medal size={14} style={{marginLeft: '0.5rem'}} />
                    عرض النتائج
                  </div>
                </div>
              </div>

              <div style={{textAlign: 'center'}}>
                <button
                  style={{...styles.secondaryButton, fontSize: 'clamp(1rem, 2vw, 1.25rem)', padding: 'clamp(0.75rem, 1.5vw, 1rem) clamp(1.5rem, 2vw, 2rem)'}}
                  onClick={() => setCurrentPage('registration')}
                >
                  <Plus size={window.innerWidth < 768 ? 20 : 24} />
                  إضافة لاعب جديد
                </button>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }

  // For other admin pages (hideseek, kingzone, trapmaster) - they will be shown with AdminLock if not admin
  // The implementation continues with mobile-responsive player cards...
  
  // MASTER SCOREBOARD PAGE - PUBLIC ACCESS
  if (currentPage === 'scoreboard') {
    const masterScores = getMasterScoreboard();

    return (
      <>
        <Alert />
        <div style={{...styles.pageContainer, background: 'linear-gradient(135deg, #0f172a 0%, #0c4a6e 50%, #0f172a 100%)', alignItems: 'flex-start', paddingTop: 'clamp(2rem, 4vw, 3rem)'}}>
          <div style={{...styles.blob1, background: '#0891b2'}} className="animate-pulse" />
          <div style={{...styles.blob2, background: '#06b6d4'}} className="animate-pulse" />
          
          <div style={styles.contentContainer}>
            <div style={styles.mobileHeader}>
              <button
                style={{...styles.glass, padding: 'clamp(0.75rem, 1.5vw, 1rem) clamp(1.5rem, 2vw, 2rem)', color: '#a5f3fc', fontWeight: '700', border: 'none', borderRadius: '1rem', cursor: 'pointer', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)', alignSelf: 'flex-start'}}
                onClick={() => setCurrentPage('registration')}
              >
                ← العودة
              </button>
              <div style={{textAlign: 'center'}}>
                <div style={{...styles.flexCenter, gap: 'clamp(0.75rem, 1.5vw, 1.5rem)', marginBottom: 'clamp(0.5rem, 1vw, 1rem)'}}>
                  <Award size={window.innerWidth < 768 ? 40 : 56} color="#22d3ee" style={{...styles.textGlow, color: '#22d3ee'}} />
                  <h1 style={{fontSize: 'clamp(2rem, 5vw, 4rem)', fontWeight: '900', ...styles.gradientTextCyan, ...styles.textGlow}}>
                    MASTER SCOREBOARD
                  </h1>
                </div>
                <div style={{...styles.badge, ...styles.badgeCyan}}>لوحة النتائج الشاملة</div>
              </div>
            </div>

            <div style={styles.card}>
              <h2 style={{fontSize: 'clamp(1.5rem, 3vw, 2.5rem)', fontWeight: '900', ...styles.gradientTextCyan, marginBottom: 'clamp(1.5rem, 2vw, 2rem)'}}>
                الترتيب النهائي
              </h2>

              {masterScores.length === 0 ? (
                <div style={{textAlign: 'center', padding: 'clamp(3rem, 5vw, 5rem) 0'}}>
                  <Award size={window.innerWidth < 768 ? 72 : 96} color="rgba(6, 182, 212, 0.2)" style={{margin: '0 auto 2rem'}} />
                  <p style={{fontSize: 'clamp(1.25rem, 2vw, 1.5rem)', fontWeight: '700', color: '#9ca3af'}}>لا يوجد نتائج بعد</p>
                </div>
              ) : (
                masterScores.map((player, index) => (
                  <div 
                    key={player.id} 
                    style={{
                      ...styles.playerCard,
                      background: index < 3 
                        ? `linear-gradient(135deg, rgba(6, 182, 212, ${0.3 - index * 0.1}) 0%, rgba(8, 145, 178, ${0.3 - index * 0.1}) 100%)`
                        : 'rgba(30, 27, 75, 0.4)',
                      borderColor: index < 3 ? 'rgba(6, 182, 212, 0.5)' : 'rgba(71, 85, 105, 0.3)',
                      borderWidth: index < 3 ? '2px' : '1px',
                    }}
                  >
                    <div style={{display: 'flex', flexDirection: window.innerWidth < 768 ? 'column' : 'row', justifyContent: 'space-between', alignItems: window.innerWidth < 768 ? 'flex-start' : 'center', gap: 'clamp(1rem, 2vw, 2rem)'}}>
                      <div style={{display: 'flex', alignItems: 'center', gap: 'clamp(1rem, 2vw, 2rem)', flex: 1, width: '100%'}}>
                        <div style={{
                          ...styles.rankBadge,
                          width: 'clamp(3rem, 7vw, 4rem)',
                          height: 'clamp(3rem, 7vw, 4rem)',
                          fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)',
                          background: index === 0 
                            ? 'linear-gradient(135deg, #fbbf24 0%, #f59e0b 100%)'
                            : index === 1
                            ? 'linear-gradient(135deg, #d1d5db 0%, #9ca3af 100%)'
                            : index === 2
                            ? 'linear-gradient(135deg, #f97316 0%, #ea580c 100%)'
                            : 'linear-gradient(135deg, #475569 0%, #1e293b 100%)',
                          color: 'white',
                          boxShadow: index < 3 ? '0 6px 20px rgba(6, 182, 212, 0.4)' : '0 4px 15px rgba(0, 0, 0, 0.3)'
                        }}>
                          {index < 3 ? <Medal size={window.innerWidth < 768 ? 20 : 28} /> : `#${index + 1}`}
                        </div>
                        <div style={{flex: 1}}>
                          <div style={{fontSize: 'clamp(1.25rem, 3vw, 2rem)', fontWeight: '900', color: 'white', marginBottom: 'clamp(0.25rem, 0.5vw, 0.5rem)', wordBreak: 'break-word'}}>
                            {player.name}
                          </div>
                          <div style={{display: 'flex', flexDirection: window.innerWidth < 600 ? 'column' : 'row', gap: 'clamp(0.5rem, 1vw, 1.5rem)', fontSize: 'clamp(0.75rem, 1.5vw, 0.875rem)', color: '#94a3b8'}}>
                            <span>Hide: <strong style={{color: '#a78bfa'}}>{player.hideSeek}</strong></span>
                            <span>King: <strong style={{color: '#fbbf24'}}>{player.kingZone}</strong></span>
                            <span>Trap: <strong style={{color: '#f87171'}}>{player.trapMaster}</strong></span>
                          </div>
                        </div>
                      </div>

                      <div style={{...styles.glass, textAlign: 'center', padding: 'clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 3vw, 2.5rem)', minWidth: window.innerWidth < 768 ? '100%' : 'auto'}}>
                        <div style={{...styles.scoreDisplay, color: '#22d3ee', fontSize: 'clamp(2rem, 5vw, 3.5rem)'}}>
                          {player.totalScore}
                        </div>
                        <p style={{color: '#a5f3fc', fontSize: 'clamp(0.75rem, 1.5vw, 0.875rem)', fontWeight: '700', marginTop: 'clamp(0.25rem, 0.5vw, 0.5rem)'}}>
                          إجمالي النقاط
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              )}

              {masterScores.length > 0 && masterScores[0] && (
                <div style={{textAlign: 'center', marginTop: 'clamp(2rem, 4vw, 4rem)'}}>
                  <div style={{...styles.glass, display: 'inline-block', padding: 'clamp(1.5rem, 3vw, 2rem) clamp(2rem, 4vw, 4rem)', maxWidth: '100%'}}>
                    <Trophy size={window.innerWidth < 768 ? 40 : 48} color="#fbbf24" style={{margin: '0 auto 1rem', display: 'block', ...styles.textGlow, color: '#fbbf24'}} />
                    <h3 style={{fontSize: 'clamp(1.5rem, 3vw, 2rem)', fontWeight: '900', ...styles.gradientTextGold, marginBottom: 'clamp(0.25rem, 0.5vw, 0.5rem)', wordBreak: 'break-word'}}>
                      🏆 البطل: {masterScores[0].name}
                    </h3>
                    <p style={{color: '#a5f3fc', fontSize: 'clamp(1rem, 2vw, 1.25rem)', fontWeight: '700'}}>
                      النقاط الإجمالية: {masterScores[0].totalScore}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  // KING OF THE ZONE PAGE - ADMIN ONLY (following same mobile-responsive pattern)
  if (currentPage === 'kingzone') {
    const displayPlayers = kingZoneSorted.length > 0 ? kingZoneSorted : players;
    const handleSort = () => setKingZoneSorted(getSortedPlayers(kingZoneScores));

    return (
      <>
        <Alert />
        <div style={{...styles.pageContainer, ...styles.goldBg, alignItems: 'flex-start', paddingTop: 'clamp(2rem, 4vw, 3rem)'}}>
          <div style={{...styles.blob1, background: '#f59e0b'}} className="animate-pulse" />
          <div style={{...styles.blob2, background: '#eab308'}} className="animate-pulse" />
          
          <div style={styles.contentContainer}>
            <div style={{...styles.flexBetween, marginBottom: 'clamp(2rem, 4vw, 3rem)'}}>
              <button
                style={{...styles.glass, padding: 'clamp(0.75rem, 1.5vw, 1rem) clamp(1.5rem, 3vw, 2rem)', color: '#fde68a', fontWeight: '700', border: 'none', borderRadius: '1rem', cursor: 'pointer', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}
                onClick={() => setCurrentPage('menu')}
              >
                ← العودة
              </button>
              <div style={{textAlign: 'center', flex: 1}}>
                <div style={{...styles.flexCenter, marginBottom: '1rem'}}>
                  <Crown size={window.innerWidth < 768 ? 40 : 56} color="#fbbf24" style={{...styles.textGlow, color: '#fbbf24'}} />
                  <h1 style={{fontSize: 'clamp(2rem, 6vw, 4rem)', fontWeight: '900', ...styles.gradientTextGold, ...styles.textGlow}}>
                    KING OF THE ZONE
                  </h1>
                </div>
                <div style={{...styles.badge, ...styles.badgeGold}}>ملك المنطقة</div>
              </div>
            </div>

            <div style={styles.card}>
              <div style={{...styles.flexBetween, marginBottom: 'clamp(1.5rem, 3vw, 2rem)'}}>
                <h2 style={{...styles.h2, ...styles.gradientTextGold}}>اللاعبون</h2>
                <button style={{...styles.secondaryButton, background: 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)'}} onClick={handleSort}>
                  <ArrowUp size={window.innerWidth < 768 ? 16 : 20} />
                  <span style={{display: window.innerWidth < 480 ? 'none' : 'inline'}}>ترتيب</span>
                </button>
              </div>

              {displayPlayers.length === 0 ? (
                <div style={{textAlign: 'center', padding: 'clamp(3rem, 6vw, 5rem) 0'}}>
                  <Users size={window.innerWidth < 768 ? 72 : 96} color="rgba(245, 158, 11, 0.2)" style={{margin: '0 auto 2rem'}} />
                  <p style={{fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)', fontWeight: '700', color: '#9ca3af'}}>لا يوجد لاعبين بعد</p>
                </div>
              ) : (
                displayPlayers.map((player, index) => (
                  <div key={player.id} style={styles.playerCard}>
                    <div style={{...styles.flexBetween, gap: 'clamp(0.5rem, 2vw, 1.5rem)'}}>
                      <div style={{display: 'flex', alignItems: 'center', gap: 'clamp(0.75rem, 2vw, 1.5rem)', flex: 1, minWidth: 0}}>
                        <div style={{...styles.rankBadge, background: index === 0 ? 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)' : 'linear-gradient(135deg, #475569 0%, #1e293b 100%)', color: 'white'}}>
                          #{index + 1}
                        </div>
                        <span style={{fontSize: 'clamp(1.125rem, 2.5vw, 1.5rem)', fontWeight: '900', color: 'white', overflow: 'hidden', textOverflow: 'ellipsis'}}>{player.name}</span>
                        {index === 0 && <Crown size={window.innerWidth < 768 ? 20 : 24} color="#fbbf24" style={{...styles.textGlow, color: '#fbbf24', flexShrink: 0}} />}
                      </div>

                      <div style={{display: 'flex', alignItems: 'center', gap: 'clamp(0.5rem, 1.5vw, 1.5rem)', flexShrink: 0}}>
                        <div style={{...styles.glass, textAlign: 'center', padding: 'clamp(0.75rem, 1.5vw, 1rem) clamp(1rem, 2vw, 2rem)'}}>
                          <div style={{...styles.scoreDisplay, color: '#fbbf24'}}>{kingZoneScores[player.id] || 0}</div>
                          <p style={{color: '#fde68a', fontSize: 'clamp(0.625rem, 1.25vw, 0.75rem)', fontWeight: '700', marginTop: '0.25rem'}}>نقطة</p>
                        </div>
                        <div style={{display: 'flex', gap: 'clamp(0.5rem, 1vw, 0.75rem)'}}>
                          <button style={{...styles.iconButton, ...styles.greenButton}} onClick={() => updateScore(player.id, 'kingzone', 1)}>
                            <Plus size={window.innerWidth < 768 ? 20 : 24} color="white" />
                          </button>
                          <button style={{...styles.iconButton, ...styles.redButton}} onClick={() => updateScore(player.id, 'kingzone', -1)}>
                            <Minus size={window.innerWidth < 768 ? 20 : 24} color="white" />
                          </button>
                          <button style={{...styles.iconButton, ...styles.deleteButton}} onClick={() => deletePlayer(player.id)}>
                            <Trash2 size={window.innerWidth < 768 ? 16 : 20} color="white" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>
          </div>
        </div>
      </>
    );
  }

  // TRAP MASTER PAGE - ADMIN ONLY
  if (currentPage === 'trapmaster') {
    const displayPlayers = trapMasterSorted.length > 0 ? trapMasterSorted : players;
    const handleSort = () => setTrapMasterSorted(getSortedPlayers(trapMasterScores));

    return (
      <>
        <Alert />
        <div style={{...styles.pageContainer, ...styles.redBg, alignItems: 'flex-start', paddingTop: 'clamp(2rem, 4vw, 3rem)'}}>
          <div style={styles.blob1} className="animate-pulse" />
          <div style={styles.blob2} className="animate-pulse" />
          
          <div style={styles.contentContainer}>
            <div style={{...styles.flexBetween, marginBottom: 'clamp(2rem, 4vw, 3rem)'}}>
              <button
                style={{...styles.glass, padding: 'clamp(0.75rem, 1.5vw, 1rem) clamp(1.5rem, 3vw, 2rem)', color: '#fca5a5', fontWeight: '700', border: 'none', borderRadius: '1rem', cursor: 'pointer', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}}
                onClick={() => setCurrentPage('menu')}
              >
                ← العودة
              </button>
              <div style={{textAlign: 'center', flex: 1}}>
                <div style={{...styles.flexCenter, marginBottom: '1rem'}}>
                  <Crosshair size={window.innerWidth < 768 ? 40 : 56} color="#f87171" style={{...styles.textGlow, color: '#f87171'}} />
                  <h1 style={{fontSize: 'clamp(1.75rem, 5vw, 4rem)', fontWeight: '900', ...styles.gradientText, ...styles.textGlow}}>
                    {window.innerWidth < 480 ? 'TRAP MASTER' : 'TRAP MASTER CHALLENGE'}
                  </h1>
                </div>
                <div style={{...styles.badge, ...styles.badgeRed}}>تحدي السيد الفخاخ</div>
              </div>
            </div>

            <div style={{...styles.card, marginBottom: 'clamp(2rem, 4vw, 3rem)'}}>
              <div style={{...styles.flexBetween, marginBottom: 'clamp(1.5rem, 3vw, 2rem)'}}>
                <h2 style={{...styles.h2, ...styles.gradientText}}>جميع اللاعبين</h2>
                <div style={{display: 'flex', gap: 'clamp(0.5rem, 1vw, 1rem)', flexWrap: 'wrap'}}>
                  <button style={{...styles.secondaryButton, background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)'}} onClick={handleSort}>
                    <ArrowUp size={window.innerWidth < 768 ? 16 : 20} />
                    <span style={{display: window.innerWidth < 480 ? 'none' : 'inline'}}>ترتيب</span>
                  </button>
                  <button style={{...styles.primaryButton, width: 'auto', padding: 'clamp(0.5rem, 1.5vw, 0.75rem) clamp(1rem, 2vw, 1.5rem)', fontSize: 'clamp(0.875rem, 1.5vw, 1rem)'}} onClick={selectTop5}>
                    <Star size={window.innerWidth < 768 ? 16 : 20} style={{marginLeft: '0.5rem'}} />
                    <span style={{display: window.innerWidth < 380 ? 'none' : 'inline'}}>اختيار أفضل 5</span>
                  </button>
                </div>
              </div>

              {displayPlayers.length === 0 ? (
                <div style={{textAlign: 'center', padding: 'clamp(3rem, 6vw, 5rem) 0'}}>
                  <Crosshair size={window.innerWidth < 768 ? 72 : 96} color="rgba(220, 38, 38, 0.2)" style={{margin: '0 auto 2rem'}} />
                  <p style={{fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)', fontWeight: '700', color: '#9ca3af'}}>لا يوجد لاعبين بعد</p>
                </div>
              ) : (
                displayPlayers.map((player, index) => (
                  <div key={player.id} style={styles.playerCard}>
                    <div style={{...styles.flexBetween, gap: 'clamp(0.5rem, 2vw, 1.5rem)'}}>
                      <div style={{display: 'flex', alignItems: 'center', gap: 'clamp(0.75rem, 2vw, 1.5rem)', flex: 1, minWidth: 0}}>
                        <div style={{...styles.rankBadge, background: index === 0 ? 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)' : 'linear-gradient(135deg, #475569 0%, #1e293b 100%)', color: 'white'}}>
                          #{index + 1}
                        </div>
                        <span style={{fontSize: 'clamp(1.125rem, 2.5vw, 1.5rem)', fontWeight: '900', color: 'white', overflow: 'hidden', textOverflow: 'ellipsis'}}>{player.name}</span>
                        {index === 0 && <Crown size={window.innerWidth < 768 ? 20 : 24} color="#fbbf24" style={{...styles.textGlow, color: '#fbbf24', flexShrink: 0}} />}
                      </div>

                      <div style={{display: 'flex', alignItems: 'center', gap: 'clamp(0.5rem, 1.5vw, 1.5rem)', flexShrink: 0}}>
                        <div style={{...styles.glass, textAlign: 'center', padding: 'clamp(0.75rem, 1.5vw, 1rem) clamp(1rem, 2vw, 2rem)'}}>
                          <div style={{...styles.scoreDisplay, color: '#f87171'}}>{trapMasterScores[player.id] || 0}</div>
                          <p style={{color: '#fca5a5', fontSize: 'clamp(0.625rem, 1.25vw, 0.75rem)', fontWeight: '700', marginTop: '0.25rem'}}>نقطة</p>
                        </div>
                        <div style={{display: 'flex', gap: 'clamp(0.5rem, 1vw, 0.75rem)'}}>
                          <button style={{...styles.iconButton, ...styles.greenButton}} onClick={() => updateScore(player.id, 'trapmaster', 1)}>
                            <Plus size={window.innerWidth < 768 ? 20 : 24} color="white" />
                          </button>
                          <button style={{...styles.iconButton, ...styles.redButton}} onClick={() => updateScore(player.id, 'trapmaster', -1)}>
                            <Minus size={window.innerWidth < 768 ? 20 : 24} color="white" />
                          </button>
                          <button style={{...styles.iconButton, ...styles.deleteButton}} onClick={() => deletePlayer(player.id)}>
                            <Trash2 size={window.innerWidth < 768 ? 16 : 20} color="white" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              )}
            </div>

            {top5Finalists.length > 0 && (
              <div style={styles.card}>
                <h2 style={{...styles.h2, ...styles.gradientText, marginBottom: 'clamp(1.5rem, 3vw, 2rem)'}}>
                  ⭐ أفضل 5 متأهلين
                </h2>

                {top5Finalists.map((finalist, index) => (
                  <div key={finalist.id} style={styles.finalistCard}>
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 'clamp(1rem, 2vw, 2rem)', flexWrap: 'wrap'}}>
                      <div style={{display: 'flex', alignItems: 'center', gap: 'clamp(1rem, 2vw, 2rem)'}}>
                        <div style={{...styles.rankBadge, width: 'clamp(3rem, 7vw, 4rem)', height: 'clamp(3rem, 7vw, 4rem)', fontSize: 'clamp(1.25rem, 2.5vw, 1.5rem)', background: 'linear-gradient(135deg, #dc2626 0%, #991b1b 100%)', color: 'white', boxShadow: '0 6px 20px rgba(220, 38, 38, 0.4)'}}>
                          #{index + 1}
                        </div>
                        <div>
                          <div style={{fontSize: 'clamp(1.25rem, 3vw, 2rem)', fontWeight: '900', color: 'white', marginBottom: '0.25rem'}}>
                            {finalist.name}
                          </div>
                          <div style={{color: '#fca5a5', fontSize: 'clamp(0.75rem, 1.5vw, 0.875rem)', fontWeight: '600'}}>
                            متأهل للنهائي
                          </div>
                        </div>
                      </div>

                      <div style={{...styles.glass, textAlign: 'center', padding: 'clamp(1rem, 2vw, 1.5rem) clamp(1.5rem, 3vw, 2.5rem)'}}>
                        <div style={{...styles.scoreDisplay, color: '#f87171', fontSize: 'clamp(2rem, 5vw, 3rem)'}}>
                          {finalist.totalScore}
                        </div>
                        <p style={{color: '#fca5a5', fontSize: 'clamp(0.75rem, 1.5vw, 0.875rem)', fontWeight: '700', marginTop: '0.5rem'}}>
                          إجمالي النقاط
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </>
    );
  }

  return null;
}
